export default __webpack_public_path__ + "static/media/paymentfailed-women.dbc90f7b.webp";